var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:({ width: _vm.tamanho }),attrs:{"src":_vm.modoPR == 'R' ? _vm.imgReceber : _vm.imgPagar}})
}
var staticRenderFns = []

export { render, staticRenderFns }